import { slugify } from 'transliteration';

export default function getOfficeSlug(office) {
  return slugify(office.name);
}
